import { onDocumentReady, Carousel, Slider } from "@story/story_assets";
import "@story/story_assets/slide";
import "@story/story_assets/snippets";
import "@story/story_assets/ajax_form";
import "@story/story_assets/turnstile";

import "@story/story_assets/modal/modal_gallery";

import "./components/images";
import "./components/cookies_consent_dialog";
import "./components/slider";
import "./components/orders";
import "./components/products";
import "./components/categories";
import "./components/notice";
import "./components/sticky_header";
import "./components/pixel_events";
import "./components/packeta";

// We are using only the purchase GTM event sent from the backend.
// I'm commenting this out for now, as it is not used and the code is deprecated itself.
// import "./components/gtm_events";


; (function() {

	window.antlerio = {};
	window.antlerio.carousels = [];

	onDocumentReady(function() {
		let carousels = document.querySelectorAll(".carousel");
		for (let i = 0; i < carousels.length; ++i) {
			let carousel = new Carousel(carousels[i]);
			window.antlerio.carousels.push(carousel);
		}

		let sliders = document.querySelectorAll(".slider");
		for (let i = 0; i < sliders.length; ++i) {
			Slider.get(sliders[i]);
		}
	});


	document.addEventSelectorListener("click", "[data-roll]", function(event, target) {
		let element = document.querySelector(target.getAttribute("data-roll"));

		if (element.classList.contains("expanded")) {
			element.classList.remove("expanded");
			element.classList.add("collapsed");
		}
		else {
			element.classList.add("expanded");
		}
	});

	document.addEventListener("click", function(event) {
		let rolls = document.querySelectorAll("[data-roll-container].expanded");
		if (!rolls.length) {
			return;
		}

		let isInside = event.target.closest("[data-roll], [data-roll-container]");
		if (isInside) {
			return;
		}

		event.preventDefault();

		for (let roll of rolls) {
			roll.classList.remove("expanded");
			roll.classList.add("collapsed");
		}
	});
}());